import { ApiVersion, httpClient, UsersService as BaseUsersService } from '@pascal/pascal-core';

export class UsersService extends BaseUsersService {
  constructor(config) {
    super(config);
  }

  async updateUserAvatar(avatarId, version = ApiVersion.v1) {
    const url = `${this.url}/api/${version}/Users/updateAvatar`;
    return httpClient.put(url, { avatarId });
  }
}
